export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Test_Mic_Not_Reading_Loud_Enough_Again.mp3";